(function () {
  let checkbox = null;
  let handleChange = null;

  function init() {
    checkbox = document.querySelector('input[data-test="enable-cash-rounding"]');
    const denom = document.querySelector('select[name="cash_rounding_denomination"]');
    const rule = document.querySelector('select[name="cash_rounding_rule"]');

    if (!checkbox || !denom || !rule) {
      return;
    }

    const setDisabled = function (enabled) {
      if (enabled) {
        denom.removeAttribute('disabled');
        rule.removeAttribute('disabled');
      } else {
        denom.setAttribute('disabled', 'disabled');
        rule.setAttribute('disabled', 'disabled');
      }
    };

    // Set initial state based on current checkbox value
    setDisabled(checkbox.checked);

    // Toggle on change
    handleChange = function () {
      setDisabled(checkbox.checked);
    };

    checkbox.addEventListener('change', handleChange);
  }

  function cleanup() {
    if (checkbox && handleChange) {
      checkbox.removeEventListener('change', handleChange);
      checkbox = null;
      handleChange = null;
    }
  }

  // Initialize on initial page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-initialize when navigating to the options page (handles AJAX navigation)
  history.onChangeState(
    [
      {
        name: ['admin.views.options'],
        form_name: 'view',
        tab: ['settings'],
      },
    ],
    init,
    cleanup
  );
})();
